import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import SEOHead from './components/SEOHead';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Promotions from './components/Promotions';
import About from './components/About';
import PriceList from './components/PriceList';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import FloatingHearts from './components/FloatingHearts';

function App() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-dulce-cream-50">

        <FloatingHearts />
        <Navbar />
        <main>
          <Hero />
          <Products />
          <Promotions />
          <About />
          <PriceList />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
        <ScrollToTop />
      </div>
    </HelmetProvider>
  );
}

export default App;